import React from 'react';


const SectionTitle1 = ({subtitle, title, description, description2, textAlignment, textColor}) => {
    const isWhyChooseUs = title === "Why choose us?";
    return (
        <div className={`section-heading ${textAlignment} ${textColor}`}>
            <div className="subtitle" dangerouslySetInnerHTML={{__html: subtitle}}></div>
            <h2 className="title" dangerouslySetInnerHTML={{__html: title}}></h2>
            <p 
                dangerouslySetInnerHTML={{ __html: description }} 
                style={isWhyChooseUs ? { width: "100%" } : {}}
            ></p>
            <p 
                dangerouslySetInnerHTML={{ __html: description2 }} 
                style={isWhyChooseUs ? { width: "100%" } : {}}
            ></p>
        </div>
    )
}

export default SectionTitle1;